import styled, { css } from 'styled-components'

import BaseIllustration from 'components/atoms/Illustration'
import { AVAILABLE_BRANDS, theme } from 'styles/theme'
import { getSize } from 'utils'

import * as S from '../../styled'

export const Container = styled(S.Container)`
  .cloud {
    transform: rotate(-90deg);
    position: fixed;
    height: 100%;
  }

  z-index: 2;

  display: grid;

  grid-template-columns: 1fr 1fr;
  grid-template-rows: 0fr 1fr;
  ${({ theme: { color } }) =>
    color === AVAILABLE_BRANDS.CLOUD_LIGHT &&
    css`
      background-color: ${theme.colors.white};
      position: relative;
      grid-template-areas:
        'details illustration'
        'description illustration';
    `}
  ${({ theme: { color } }) =>
    color === AVAILABLE_BRANDS.CLOUD_DARK &&
    css`
      background-color: ${theme.colors.cloudPurple};
      grid-template-areas:
        'illustration details'
        'illustration description';
    `}
  .background-image {
    mask-size: ${getSize(3003)} ${getSize(3028)};
    mask-position: ${getSize(-1008)} ${getSize(-1142)};
    opacity: 1;
    z-index: -1;
  }

  @media (max-aspect-ratio: 1/1) {
    grid-template-areas:
      'illustration'
      'details'
      'description';
    grid-template-columns: 1fr;
    ${({ theme: { color } }) =>
      color === AVAILABLE_BRANDS.CLOUD_LIGHT &&
      css`
        grid-template-rows: ${getSize(681)} 0fr 1fr;
        padding-top: ${getSize(327)};
        .background-image {
          mask-position: ${getSize(-677)} ${getSize(-1060)};
        }
      `}
    ${({ theme: { color } }) =>
      color === AVAILABLE_BRANDS.CLOUD_DARK &&
      css`
        grid-template-rows: ${getSize(665)} 0fr 1fr;
        .background-image {
          mask-position: ${getSize(-772)} ${getSize(-1170)};
        }
      `}
  }
`

export const Title = styled.div`
  grid-area: title;
  position: absolute;
  width: ${getSize(565)};
  box-sizing: content-box;

  ${({ theme: { color } }) =>
    color === AVAILABLE_BRANDS.CLOUD_LIGHT &&
    css`
      top: ${getSize(88)};
      left: ${getSize(164)};
      padding: ${getSize(0)};
      color: ${theme.colors.cloudPurple};
      font-family: 'Poppins';
      font-weight: 400;
      font-size: ${getSize(46)};
      text-transform: uppercase;
      span {
        background-color: ${theme.colors.limeGreen};
        line-height: ${getSize(80)};
      }
    `}
  ${({ theme: { color } }) =>
    color === AVAILABLE_BRANDS.CLOUD_DARK &&
    css`
      top: ${getSize(88)};
      right: ${getSize(88)};
      padding: ${getSize(0)};
      color: ${theme.colors.cloudPurple};
      font-family: 'Poppins';
      font-size: ${getSize(46)};
      font-weight: 400;
      text-transform: uppercase;
      span {
        background-color: ${theme.colors.limeGreen};
        line-height: ${getSize(80)};
      }
    `}
  @media (max-aspect-ratio: 1/1) {
    ${({ theme: { color } }) =>
      color === AVAILABLE_BRANDS.CLOUD_LIGHT &&
      css`
        background-color: ${theme.colors.limeGreen};
        color: ${theme.colors.cloudPurple};
        left: ${getSize(78)};
        width: ${getSize(756)};
        font-size: ${getSize(82)};
        line-height: ${getSize(98)};
        top: ${getSize(135)};
        padding: ${getSize(24)};
      `}
    ${({ theme: { color } }) =>
      color === AVAILABLE_BRANDS.CLOUD_DARK &&
      css`
        left: ${getSize(80)};
        top: ${getSize(913)};
        width: ${getSize(620)};
        font-size: ${getSize(82)};
        line-height: ${getSize(81)};
        color: ${theme.colors.cloudPurple};
        background-color: ${theme.colors.limeGreen};
      `}
  }
`

export const Details = styled.div`
  grid-area: details;
  ${({ theme: { color } }) =>
    color === AVAILABLE_BRANDS.CLOUD_LIGHT &&
    css`
      margin-left: ${getSize(140)};
      margin-right: ${getSize(254)};
      padding-top: ${getSize(360)};
      padding-right: ${getSize(64)};
      padding-left: ${getSize(24)};
      text-transform: uppercase;
      color: ${theme.colors.cloudPurple};
      font-family: 'Poppins';
      font-size: ${getSize(30)};
      font-weight: 700;
      line-height: ${getSize(36)};
      padding-top: ${getSize(300)};
    `}
  ${({ theme: { color } }) =>
    color === AVAILABLE_BRANDS.CLOUD_DARK &&
    css`
      margin-left: ${getSize(330)};
      margin-right: ${getSize(64)};
      padding-top: ${getSize(360)};
      padding-right: ${getSize(64)};
      padding-left: ${getSize(24)};
      text-transform: uppercase;
      color: ${theme.colors.white};
      font-family: 'Poppins'
      font-weight: 700;
      font-size: ${getSize(30)};
      line-height: ${getSize(36)};
      padding-top: ${getSize(300)};

      `}


  .separator {
    width: ${getSize(27)};
    height: ${getSize(6)};
    margin-top: ${getSize(14)};
    background-color: ${theme.colors.limeGreen};
  }

  @media (max-aspect-ratio: 1/1) {
    background-color: transparent;
    ${({ theme: { color } }) =>
      color === AVAILABLE_BRANDS.CLOUD_LIGHT &&
      css`
        border: ${getSize(1)} solid ${theme.colors.limeGreen};
        border-top: none;
        padding: ${getSize(24)};
        padding-top: ${getSize(19)};
        margin: 0;
        margin-left: ${getSize(521)};
        width: ${getSize(480)};
        height: auto;
      `}
    ${({ theme: { color } }) =>
      color === AVAILABLE_BRANDS.CLOUD_DARK &&
      css`
        margin-top: ${getSize(91)};
        margin-left: 0;
        padding: 0;
        height: auto;
        text-align: right;
        color: ${theme.colors.limeGreen};
        margin-right: ${getSize(129)};
      `}
   

    .separator {
      display: none;
    }
  }
`

export const Description = styled.div`
  grid-area: description;
  padding-top: ${getSize(40)};
  padding-right: ${getSize(64)};
  padding-left: ${getSize(24)};
  height: 100%;
  white-space: pre-wrap;
  background-color: transparent;
  font-weight: 400;
  font-family: 'Poppins';
  font-size: ${getSize(24)};
  line-height: ${getSize(29)};
  ${({ theme: { color } }) =>
    color === AVAILABLE_BRANDS.CLOUD_LIGHT &&
    css`
      margin-left: ${getSize(140)};
      margin-right: ${getSize(254)};
      color: ${theme.colors.cloudPurple};
    `}
  ${({ theme: { color } }) =>
    color === AVAILABLE_BRANDS.CLOUD_DARK &&
    css`
      margin-left: ${getSize(330)};
      margin-right: ${getSize(64)};
      color: ${theme.colors.white};
    `}

  & > span {
    font-weight: 700;
    font-size: ${getSize(32)};
    line-height: ${getSize(39)};
  }

  @media (max-aspect-ratio: 1/1) {
    width: 100%;
    margin: 0;
    box-sizing: border-box;
    ${({ theme: { color } }) =>
      color === AVAILABLE_BRANDS.CLOUD_LIGHT &&
      css`
        margin-top: ${getSize(64)};
        padding: ${getSize(64)} ${getSize(80)} ${getSize(132)};
      `}
    ${({ theme: { color } }) =>
      color === AVAILABLE_BRANDS.CLOUD_DARK &&
      css`
        margin-top: ${getSize(196)};
        padding: ${getSize(191)} ${getSize(80)} ${getSize(131)};
      `}
  }
`
export const Illustration = styled(BaseIllustration)`
  grid-area: illustration;
  ${({ theme: { color } }) =>
    color === AVAILABLE_BRANDS.CLOUD_LIGHT &&
    css`
      z-index: -1;
      @media (max-aspect-ratio: 1/1) {
        margin: 0 ${getSize(30)};
        width: calc(100% - ${getSize(60)});
      }
    `}
  ${({ theme: { color } }) =>
    color === AVAILABLE_BRANDS.CLOUD_DARK &&
    css`
      @media (max-aspect-ratio: 1/1) {
        margin-left: ${getSize(85)};
        width: calc(100% - ${getSize(85)});
      }
    `}
`
